import { SET_SPQ_QUEUE_ITEM, CLEAN_SPQ_QUEUE_ITEM } from '../constants/videoPlayer.constants';

export const setSpqQueueItem = (payload) => {
  return {
    type: SET_SPQ_QUEUE_ITEM,
    payload
  };
};
export const cleanSpqQueueItem = (payload = '') => {
  return {
    type: CLEAN_SPQ_QUEUE_ITEM,
    payload
  };
};
